<script lang="ts">
    import { onMount } from 'svelte'
    import { writable } from 'svelte/store'

    import { toASCII, toUnicode } from 'punycode-esm'
    import * as yup from 'yup'

    import { gettext as _, tgettext } from 'hydria/services/gettext'
    import { simpleFetch, type SimpleFetchResult } from 'hydria/services/session'
    import { sgoto, sreplace } from 'hydria/svelte_helpers'

    import { Breadcrumb } from 'breadcrumb'

    import MiniKeyboard from 'wdom/components/MiniKeyboard.svelte'

    interface Props {
        route: any
    }

    let { route }: Props = $props()

    const crumbs = [
        {
            txt: tgettext('WHOIS lookup'),
        },
    ]

    const error = writable(null)
    const result = writable(null)
    const running = writable(false)

    const form = $state({
        name: '',
    })

    let inDomainName: string = $derived(route.result.path.params.domainName ? route.result.path.params.domainName : '')
    let inAscii: string = $derived(inDomainName ? toASCII(inDomainName) : '')
    let inUnicode: string = $derived(inDomainName ? toUnicode(inDomainName) : '')

    function loadParams(value: string, initial: boolean = false) {
        // inAscii = value ? toASCII(value) : ''
        // inUnicode = value ? toUnicode(value) : ''
        form.name = inUnicode

        if (inDomainName != inAscii) {
            const path = inAscii ? `/whois/${inAscii}` : '/whois/'
            if (initial) {
                sreplace(path)
            } else {
                sgoto(path)
            }
        } else {
            loadData()
        }
    }

    onMount(() => {
        loadParams(inDomainName, true)
    })

    async function loadData() {
        if (!inAscii) {
            form.name = ''
            return
        }
        running.set(true)
        form.name = inUnicode != null ? inUnicode : ''
        let r: SimpleFetchResult
        try {
            r = await simpleFetch('GET', `/json/general/1/whois/${inAscii}`)
            result.set(r.data.whois_text)
        } catch (e: any) {
            console.error('Error loading data:', e)
            if (e && e.data) error.set(e.data.error ? e.data.error : 'error')
        }
        running.set(false)
    }

    const schema = yup.object().shape({
        name: yup.string().required().label($_('Domain')),
    })
    let isValid = $derived(schema.isValidSync(form))

    function onsubmit(e: Event) {
        e.preventDefault()
        if (!isValid) {
            return
        }
        if (form.name && form.name != inUnicode) sgoto('/whois/' + toASCII(form.name))
    }
</script>

<Breadcrumb {crumbs} />

<div class="card">
    <div class="card-title text-primary">{$_('Lookup')}</div>
    <div class="card-body">
        <form name="lookupForm" {onsubmit}>
            <div class="input-group">
                <input class="form-control" id="whoisName" type="text" placeholder={$_('WHOIS entry to lookup')} name="name" bind:value={form.name} required />
                <MiniKeyboard eid={'whoisName'} />
                <button class="btn btn-outline-primary search" type="submit" disabled={$running || !isValid}>{$_('Lookup')}</button>
            </div>
        </form>
    </div>
    {#if $running}
        <div class="card-body">
            <div class="loading d-grid justify-content-center"><div class="spinner-border m-3" role="status" aria-hidden="true"></div></div>
        </div>
    {:else}
        {#if $result != null}
            <div class="card-body">
                <div>
                    <pre>{$result}</pre>
                </div>
            </div>
        {/if}
        {#if $error != null}
            <div class="card-body">
                <div class="404 no-margin">
                    <div class="alert alert-danger">
                        <i class="icon-warning-sign"></i>
                        {$error}
                    </div>
                </div>
            </div>
        {/if}
    {/if}
</div>
